"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var EditorTexElement = function (_a) {
    var attributes = _a.attributes, children = _a.children;
    var selected = slate_react_1.useSelected();
    var focused = slate_react_1.useFocused();
    return (react_1.default.createElement("span", __assign({}, attributes, { style: {
            verticalAlign: 'baseline',
            borderRadius: '4px',
            backgroundColor: '#eee',
            fontSize: '0.9em',
            boxShadow: selected && focused ? '0 0 0 2px #B4D5FF' : 'none',
        } }), children));
};
exports.default = EditorTexElement;
//# sourceMappingURL=EditorTexElement.js.map